import React from 'react';
import { useIconThemed } from '../use-icon-themed';
export default function IconPanelWarning() {
  var _useIconThemed = useIconThemed(),
    iconThemed = _useIconThemed.iconThemed;
  return /*#__PURE__*/React.createElement("svg", {
    focusable: "false",
    "aria-hidden": true,
    width: 40,
    height: 40,
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: iconThemed({
      light: '#FFF',
      dark: '#161A1D'
    }),
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: iconThemed({
      light: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
      dark: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)"
    }),
    x: 8,
    y: 12,
    width: 32,
    height: 16,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.847 16.83l2.808 5.73a1 1 0 01-.898 1.44h-6.514a1 1 0 01-.898-1.44l2.808-5.73a1.5 1.5 0 012.694 0zm-1.347.46a.568.568 0 00-.564.635l.278 2.32a.288.288 0 00.572 0l.278-2.32a.568.568 0 00-.564-.635zm0 5.035c.318 0 .576-.293.576-.656 0-.362-.258-.656-.576-.656-.318 0-.576.294-.576.656 0 .363.258.656.576.656z",
    fill: iconThemed({
      light: "var(--ds-icon-warning, #E56910)",
      dark: "var(--ds-icon-warning, #E56910)"
    })
  })));
}